// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__ygb+Q","links":"Footer_links__6D59o","copyright":"Footer_copyright__pMsMl","about":"Footer_about__AqkIr"};